import React from 'react';

import PropTypes from 'prop-types';
import { Button, Icon } from 'antd';
import { Tooltip } from 'clad';
import Block from '../Block/Block.js';

import styled, { createGlobalStyle } from 'styled-components';
import { Manager, Target, Popper } from 'react-popper';

import ClickHandle from '../../internals/ClickHandle';

const GlobalStyles = createGlobalStyle`
    .popper {
        z-index: 999999;
    }
`;

const marginSize = {
    default: '10px 0',
    large: '15px 0',
    small: '5px 0'
};

const StyledMultiSelectContainer = styled.div`
    position: relative;
    margin: ${props => `${marginSize[props.size]}`};
    display: ${props => (props.visible ? '' : 'none')};
    border: 1px solid #ddd;
    background: #fff;
    border-radius: 3px;

    .clad-block .content {
        -ms-flex: 1 0 auto;
    }

    ul {
        list-style: none;
        margin: 0;
        padding: 0;
        max-height: 250px;
        min-width: 200px;
        min-height: ${props => (props.loading ? '80px' : '20px')};
        overflow: hidden;
        overflow: auto;
        li {
            padding: 10px;
            cursor: pointer;
            :hover {
                background: #efefef;
            }
        }
    }
`;

const StyledSelectedWrapper = styled.div`
    float: left;
    padding-right: 10px;
    text-transform: none;
    * {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: ${props => (props.width ? `${props.width}px` : 'auto')};
        text-align: left;
    }
`;

class DropDownSelect extends React.Component {
    static propTypes = {
        size: PropTypes.oneOf(['large', 'default', 'small']),
        width: PropTypes.number,
        loading: PropTypes.bool,
        position: PropTypes.oneOf([
            'bottom',
            'bottom-start',
            'bottom-end',
            'top',
            'top-end',
            'top-start',
            'left',
            'left-start',
            'left-end',
            'right',
            'right-start',
            'right-end'
        ]),
        /** items list renderer. */
        render: PropTypes.func,
        /** custome renderer for selected items. */
        renderSelected: PropTypes.func,
        /** fire this function on dropdown open. */
        onOpen: PropTypes.func,
        /** fire this function on dropdown close. */
        onClose: PropTypes.func,
        /** function called when an item selected. */
        onSelect: PropTypes.func,
        /** close dropdown menu when scrolling the document. */
        onSelectClose: PropTypes.bool,
        /** initial selected value, you can use value prop to control selected values from your state. */
        defaultValue: PropTypes.node,
        /** selected value. */
        value: PropTypes.node
    };

    static defaultProps = {
        size: 'default',
        position: 'bottom-start',
        render: data => {
            return <div>{data}</div>;
        },
        onOpen: () => {},
        onClose: () => {},
        onSelect: () => {},
        loading: false,
        onSelectClose: true
    };

    buttonClicked = false;

    state = {
        visible: false,
        selected: [this.props.defaultValue]
    };

    onScrollClose = e => {
        if (e.target === this.ulElement) {
            return false;
        }

        this.handleClose();
    };

    handleClick = () => {
        const { visible } = this.state;
        const { props } = this;

        if (!visible) {
            document.addEventListener('scroll', this.onScrollClose, true);
            this.buttonClicked = true;
            this.setState({
                visible: true
            });
            props.onOpen();
        } else {
            this.handleClose();
        }
    };

    handleClose = () => {
        const { props, state } = this;
        if (this.buttonClicked || state.visible === false) {
            this.buttonClicked = false;
            return;
        }

        document.removeEventListener('scroll', this.onScrollClose, true);
        props.onClose();
        this.setState({
            visible: false
        });
    };

    handleSelect = (data, index) => {
        const { props } = this;
        this.handleClose();
        props.onSelect(data, index);
        this.setState({
            selected: [props.data[index]]
        });
    };

    render() {
        const { props, state } = this;
        const renderSelected = props.renderSelected || props.render;
        const selectedValues = props.value ? [props.value] : state.selected;

        return (
            <Manager className={props.className} style={{ ...props.style }}>
                <Target className="clad-dropdown-target" preventOverflow={true}>
                    {({ targetProps }) => (
                        <span {...targetProps}>
                            <Tooltip title={props.value}>
                                <Button
                                    size={props.size}
                                    onClick={this.handleClick}
                                >
                                    {selectedValues.map((data, index) => {
                                        const i = props.data.findIndex(
                                            item => data === item
                                        );
                                        return (
                                            <StyledSelectedWrapper
                                                className="selected-item-wrapper"
                                                width={props.width}
                                                key={Math.random()}
                                            >
                                                <div>
                                                    {renderSelected(data, i)}
                                                </div>
                                            </StyledSelectedWrapper>
                                        );
                                    })}
                                    <Icon
                                        type={state.visible ? 'up' : 'down'}
                                    />
                                </Button>
                            </Tooltip>
                        </span>
                    )}
                </Target>
                <Popper placement={props.position}>
                    {({ popperProps, restProps }) => (
                        <ClickHandle onClickOutside={this.handleClose}>
                            <div className="popper" {...popperProps}>
                                <GlobalStyles />
                                <StyledMultiSelectContainer
                                    loading={props.loading}
                                    size={props.size}
                                    {...state}
                                >
                                    <Block
                                        loading={props.loading}
                                        header={props.header}
                                        footer={props.footer}
                                    >
                                        <ul
                                            ref={el => {
                                                this.ulElement = el;
                                            }}
                                        >
                                            {props.data.map((data, index) => (
                                                <li
                                                    onClick={() =>
                                                        this.handleSelect(
                                                            data,
                                                            index
                                                        )
                                                    }
                                                    key={Math.random()}
                                                >
                                                    {props.render(data, index)}
                                                </li>
                                            ))}
                                        </ul>
                                    </Block>
                                </StyledMultiSelectContainer>
                            </div>
                        </ClickHandle>
                    )}
                </Popper>
            </Manager>
        );
    }
}

export default DropDownSelect;
